
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/training/downloads",
      function () {
        return require("private-next-pages/training/downloads.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/training/downloads"])
      });
    }
  